import * as Sentry from '@sentry/react';
import type { Extras } from '@sentry/types';

type Message = {
  error: Error;
  extra?: Extras;
  errorType: (typeof SentryErrorType)[keyof typeof SentryErrorType];
};

export const SentryErrorType = {
  GRAPHQL_ERROR: 'GRAPHQL_ERROR',
} as const;

export const captureExceptionInSentry = ({ error, extra = {}, errorType }: Message) => {
  try {
    Sentry.captureException(error, {
      extra,
      tags: {
        feature: 'Campaigns',
        errorType,
      },
    });
  } catch {
    // eslint-disable-next-line no-console
    console.error('[Campaigns]: Unable to capture this exception in Sentry', { error });
  }
};
